import Phaser from 'phaser';
import { CANVAS_W, CANVAS_H } from './types';
import { BootScene } from './scenes/BootScene';
import { GameScene } from './scenes/GameScene';
import { MenuScene } from './scenes/MenuScene';
import { NameInputScene } from './scenes/NameInputScene';
import { PauseScene } from './scenes/PauseScene';
import { StoryScene } from './scenes/StoryScene';
import { VictoryScene } from './scenes/VictoryScene';
import { HUDScene } from './scenes/HUDScene';
import { ContinueOverlay } from './scenes/ContinueOverlay';
import { SettingsScene } from './scenes/SettingsScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#131120',
  width: CANVAS_W,
  height: CANVAS_H,
  pixelArt: true,
  // Keep the WebGL buffer between frames so external screenshot tools (and
  // user-facing screenshots) capture the rendered state.
  render: { preserveDrawingBuffer: true },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: CANVAS_W,
    height: CANVAS_H,
  },
  scene: [BootScene, MenuScene, NameInputScene, StoryScene, GameScene, HUDScene, ContinueOverlay, PauseScene, VictoryScene, SettingsScene],
};

const game = new Phaser.Game(config);

if (import.meta.env.DEV) {
  (window as unknown as { GAME: Phaser.Game }).GAME = game;
}

// Runtime error telemetry — logs to console and could be wired to Sentry.
window.addEventListener('error', (e) => {
  console.error('[BOMBASTIK] uncaught error', e.message, e.error);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('[BOMBASTIK] unhandled promise rejection', e.reason);
});
